"use strict";
import Swal from 'sweetalert2/dist/sweetalert2';
import './scss';
import './icons';
import './sideMenu/index';
import './sideMenu/LetterAvatar';
import './realTimeNotifications/index';
import './callbackNotifications/index';
import Tooltip from 'bootstrap/js/dist/tooltip';
import "bootstrap/js/dist/tab";
import "bootstrap/js/src/dropdown";
import "bootstrap/js/src/tab";


export default (function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })

    global.spinnerOn = function spinnerOn(submitInputId, disableFields = true) {
        let button = $("#" + submitInputId);
        button.children("span").hide();
        button.children("div").css("display", "flex");
        button.children(".spinner-border").css("display", "inline-block");
        if (disableFields) {
            $('form input[type=text], form input[type=email], form textarea, form select, form button').addClass('disabled');
            $('form input[type=checkbox], form input[type=radio]').parent().addClass('disabled');
        }
    };

    global.spinnerOff = function spinnerOff(submitInputId, enableFields = true) {
        let button = $("#" + submitInputId);
        button.children("span").show();
        button.children("div").css("display", "none");
        button.children(".spinner-border").css("display", "none");
        if (enableFields) {
            $('form input, form textarea, form select, form button').removeClass('disabled');
            $('form input[type=checkbox], form input[type=radio]').parent().removeClass('disabled');
        }
    };

    global.updateUserNotification = function updateUserNotification() {
        $.get("/TodoNotificationList")
            .done(function (data) {
                $("#notificationMenu").find(".allTodo").text("").append(data);
                configureNotificationTab();
                configureNotificationClick();
            })
            .fail(function (data) {
            });

        configureQuickReplies();
    }

    global.sendNotificationsViewed = function sendNotificationsViewed(notificationTab) {
        let allNotificationsId = [];
        let notifications = $(notificationTab).children("div");

        notifications.each(function (index, data) {
            if ($(data).data("notificationviewed") === "False") {
                let notificationId = $(data).data("notificationid");
                if (notificationId !== undefined) {
                    allNotificationsId.push(parseInt(notificationId));
                }
            }
        });
        
        if (allNotificationsId.length > 0) {
            $.post("/api/Notification/SendNotificationsViewed", { allNotificationsId })
                .done(function () {
                    notifications.each(function (index, data) {
                        $(data).data("notificationviewed", "True");
                    });
                    let notificationsCountSpan = $("#unseenNotifications");
                    let notificationsCountSpanInt = parseInt(notificationsCountSpan.text());
                    if (!Number.isNaN(notificationsCountSpanInt)) {
                        let notificationCount = notificationsCountSpanInt - allNotificationsId.length;
                        if (notificationCount > 0) {
                            $(notificationsCountSpan).css("display", "flex");
                            notificationsCountSpan.text(notificationCount);
                        } else {
                            $(notificationsCountSpan).css("display", "none");
                        }
                    }
                })
                .fail(function (data) {
                    if (data && data.status == 401) {
                        document.location.reload();
                    }
                });
        }
    }

    global.addNotificationCount = function addNotificationCount(quantity) {
        let notificationsCountSpan = $("#unseenNotifications");
        let notificationsCountSpanInt = parseInt(notificationsCountSpan.text());
        if (!Number.isNaN(notificationsCountSpanInt)) {
            if (quantity > 0) {
                $(notificationsCountSpan).css("display", "flex");
            }
            notificationsCountSpan.text(quantity);
        }
    }

    if ($("#UserIsAuthenticated").val() === "True") {
        updateUserNotification();
    }

    global.configureNotificationTab = function configureNotificationTab() {
        [].map.call(document.querySelectorAll('.mdc-tab-bar-notification'), function (el) { return new MDCTabBar(el); });

        $('.nav-link').off('click').click(function (e) {
            if ($("#pills-notification-tab").hasClass("active")) {
                sendNotificationsViewed($("#notificationMenu").find(".allNotifications"));
            }
        });
        configureQuickReplies();
    }

    global.configureNotificationClick = function configureNotificationClick() {
        $(".confirmationCheckBoxHeader").off("click").click(function (e) {
            e.preventDefault();
            let checkbox = $(this);
            let row = checkbox.closest(".mainpanelheader__row");
            if (checkbox.prop("checked")) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to uncheck!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, check it!'
                }).then((result) => {
                    if (result.value) {
                        let notificationIdInt = parseInt(row.data("notificationid"));
                        $.post("/api/Notification/ConfirmNotification", { notificationId: notificationIdInt })
                            .done(function (data) {
                                checkbox.prop("checked", true);
                                checkbox.attr("readonly", "readonly");
                                checkbox.attr("tabindex", "-1");
                                checkbox.css("pointer-events", "none");
                                row.find(".mainpanelheader__row--todo__messages__secondmessage").text(data.message);
                                Swal.fire("Success", "Notification updated.", "success");
                                $(row).data("notificationviewed", "True");
                                let notificationsCountSpan = $("#unseenNotifications");
                                let notificationsCountSpanInt = parseInt(notificationsCountSpan.text());
                                if (!Number.isNaN(notificationsCountSpanInt)) {
                                    let notificationCount = notificationsCountSpanInt - 1;
                                    if (notificationCount > 0) {
                                        $(notificationsCountSpan).css("display", "flex");
                                        notificationsCountSpan.text(notificationCount);
                                    } else {
                                        $(notificationsCountSpan).css("display", "none");
                                    }
                                }
                            })
                            .fail(function (data) {
                                if (data && data.status == 401) {
                                    document.location.reload();
                                }
                                else {
                                    checkbox.prop("checked", false);
                                    Swal.fire("Ops...", "Sorry, we couldn't finish the process.", "error");
                                }
                            });
                    }
                });
            }
        });
    }

    global.configureMainSearch = function configureMainSearch() {
        $("#mainSearchForm").submit(function () {
            global.spinnerOn("searchSubmit")
        });
    }

    configureMainSearch();

    if ($("#mainSearchCurrency").length > 0) {
        $("#mainSearchCurrency").off("change").change(function () {
            let currencySelected = $(this).val();
            let spinner = $(this).parent().siblings("div");
            $.ajaxSetup({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("XSRF-TOKEN", $("#mainSearchForm").find('input:hidden[name="__RequestVerificationToken"]').val());
                }
            });

            spinner.css("display", "flex");
            $.post("/UpdateCurrencyView", { currencySelected })
                .done(function (data) {
                    location.reload();
                })
                .fail(function (data) {
                    if (data && data.status == 401) {
                        document.location.reload();
                    }
                    else {
                        spinner.css("display", "none");
                        let message = 'Something is not right. Please, try again later!';
                        if (data.responseJSON && data.responseJSON.message) {
                            message = data.responseJSON.message;
                        }
                        Swal.fire('Ops...', message, 'error');
                    }
                });
        });
    }


    function configureQuickReplies() {
        $('.mainpanelheader__row--notification__reply a').off('click').on('click', function (e) {
            $('.mainpanelheader__row--notification__reply__input').toggleClass('visible');
        });
        $('.mainpanelheader__row--notification__reply__input__send').off('click').on('click', function (e) {
            var btnSend = $(this);
            var textInput = btnSend.siblings('input[type=text]');
            if (textInput.length <= 0) {
                return;
            }

            if (textInput.val().replace(' ', '').length <= 0) {
                $('.mainpanelheader__row--notification__reply__error').text('You must enter a message to send.').css('display', 'block');
                return;
            } else {
                $('.mainpanelheader__row--notification__reply__error').empty().hide();
            }

            btnSend[0].disabled = true;
            btnSend.removeClass('c-icon--paper-plane');
            btnSend.html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>`);

            var conversationId = btnSend.data('conversation-id');
            var msgType = btnSend.data('message-type')
            var entityType = btnSend.data('entity-type');

            $.post('/api/messaging/sendBulkMessage', {
                toConversationIds: [conversationId],
                messageType: msgType,
                messageTemplate: null,
                messageBody: textInput.val(),
                entityType: entityType,
            })
                .done(function (response) {
                    btnSend[0].disabled = false;
                    btnSend.empty();
                    btnSend.addClass('c-icon--paper-plane');
                    textInput.val('');

                    if (global.getSelectedContactId === conversationId && global.refreshMessageChat) {
                        global.refreshMessageChat();
                    }

                    $('.mainpanelheader__row--notification__reply a').trigger('click');
                    Swal.fire('Message Sent', 'Your message has been sent.', 'info');
                }).
                fail(function (xhr, status, error) {
                    btnSend[0].disabled = false;
                    btnSend.empty();
                    btnSend.addClass('c-icon--paper-plane');

                    if (xhr && xhr.status == 401) {
                        document.location.reload();
                    }
                    else {
                        Swal.fire('Oops', 'An error occurred when sending your message: ' + error, 'error');
                    }
                });
        });
    }
}());